var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron jumbotron-fluid bg-secondary text-white"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"display-4 wf-notosansjapanese"},[_vm._v("ひらがな")]),_vm._v(" "),_c('p',{staticClass:"lead mb-0"},[_vm._v("히라가나")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f6c2f6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Jumbotron.vue
// module id = 46
// module chunks = 0